import { useState} from 'react';
import { withFormsy, addValidationRule } from 'formsy-react';
import { PatternFormat, NumericFormat } from 'react-number-format';
import DOMPurify from 'dompurify';
import "react-datepicker/dist/react-datepicker.css";
import { COUNTRY_CODE, COUNTRY_CODE_REGEX, ROUNDOFF_TO_MAX_LIMIT } from '../../../config/constants';
import {Tooltip} from 'react-tippy';
import checkIcon from "../../../webroot/images/icon.svg";

// Added common validation rule for all phone numbers
addValidationRule("isValidPhoneNumber", (values, value) => {
  if (value) {
    value = value.trim();
    if (value.includes(COUNTRY_CODE)) {
      value = value.replace(COUNTRY_CODE_REGEX, "").replace(/\s/g, "")
    }
    if (value[0] !== '9') return "Phone number must start with 9";
    if (value.length !== 10) return "Must be of 10 digits";
  }
  return true;
})

addValidationRule("isValidTelephonePhoneNumber", (values, value) => {
  if (value) {
    value = value.trim();
    if (value.length !== 11) return "Must be of 11 digits";
  }
  return true;
})

addValidationRule("ucrfMaxAmountLength", (values, value) => {
  if (value) {
    const [intPart, decPart] = value?.toString().split(".");
    if (decPart) {
      if ((intPart?.length + decPart?.length) > 16) {
        return "Max length of amount could be 16";
      }
    } else if (value?.toString()?.length > 16) {
      return "Max length of amount could be 16";
    }
  }
  return true;
});

const getMax16DigitValidation = (type, value) => {
  if (type === 'percent') {
    let validated = value > 100 ? false : true;
    let valueToUpdate = value;
    if (validated) {
      if (valueToUpdate === '' || (valueToUpdate >= 0 && valueToUpdate <= 100 && valueToUpdate.length <= 16)) {
        return valueToUpdate;
      }
    }
  } else {
    let validated = value?.replace('.', '').length > 16 ? false : true;
    let valueToUpdate = value;
    if (validated) {
      return valueToUpdate;
    } else {
      return valueToUpdate.substring(0, 16);
    }
  }
};

const FormsyInputField = (props) => {
  const [openTooltip, setOpenTooltip] = useState(null);
  const changeHandler = event => {
    const { value, id } = event.target;
    if (!props.errorMessage && value) {
      document.getElementById(id).style.border = "1px solid #bbbbbb";
    }
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
    if (props?.valueLength) {
      const trimmedValue = ROUNDOFF_TO_MAX_LIMIT(event.target.value, props?.valueLength)
      props.setValue(trimmedValue);
    }
    else {
      let value = event.target.value;
      if (props.rule === 'max16DigitValidation') {
        value = getMax16DigitValidation('percent',value);
      }
      if (value !== undefined) {
        props.setValue(value);
      }
    }
  };

  const patternFormatChangeHandler = (data) => {
    if (typeof props.onChange === "function") {
      props.onChange(data);
    }
    if (props?.valueLength) {
      const trimmedValue = ROUNDOFF_TO_MAX_LIMIT(data.value, props?.valueLength)
      props.setValue(trimmedValue);
    }
    else {
      let value  = data.value
      if (props.rule === 'max16DigitValidation') {
        value = getMax16DigitValidation('amount', value);
      }
      if (value !== undefined) {
        props.setValue(value);
      }
    }
  }

  const blurHandler = event => {
    const { value, id } = event.target;
    event.target.value = DOMPurify.sanitize(value);
    let errorElement = document
      .getElementById(id)
      .parentNode.querySelector(".error");
    if (props.isRequired && value === '') {
      document.getElementById(id).style.border = "1px solid red";
    }
    let formField = document.getElementById(id).closest(".form-field");
    if (value === "") {
      if (errorElement) errorElement.classList.remove("hide");
      if (formField) formField.classList.remove("active");
    } else {
      if (errorElement) errorElement.classList.add("hide");
      if (formField) formField.classList.add("active");
    }
  }

  const focusHandler = event => {
    const { id } = event.target;
    let formField = document.getElementById(id).closest(".form-field");
    if (formField) formField.classList.add("active");
  };

  let label = props.label;
  // To elipsize long label
  let labeltxtClass = (label && label.length && label.length >= 25) && props.col !== "col-md-12" ? 'label-txt' : '';
  if (props.isRequired || props.showAsterisk) label += " *";

  if (props.showAsterisk === false) {
    label = label?.replace('*', '');
  }

  let Formatter = props.type === "pattern-format" ? PatternFormat : NumericFormat;
  let decimalScale = props?.decimalScale >= 0 ? props?.decimalScale : 2;
  // console.log(decimalScale,props?.decimalScale,"rrrrrrrrrrrrrrrrrrrr")
  return (
    <>
      {["text", "tb", "password", "email"].includes(props.type) ? (
        <div class="material">
          <input
            {...props}
            autoComplete="new-off"
            style={{ border: props.errorMessage ? "1px solid red" : "" }}
            className={
              props.className
                ? props.className
                : "form-input"
            }
            title={labeltxtClass ? label : ""}
            onChange={changeHandler}
            onBlur={blurHandler}
            onFocus={focusHandler}
            aria-label={label}
          />
          {props.errorMessage ? (
            <div className="error-msg-txt">{props.errorMessage}</div>
          ) : (
            ""
          )}
          <label data-label={label} class={`form-label ${labeltxtClass}`}></label>
          {(
            ["vat_back_percentage"].includes(props.name) && (
              <>
                <i onClick={() => setOpenTooltip(prev => (prev === props.name ? null : props.name))} className='ic-info-icon1 info-icon-input'></i>
                <Tooltip
                  html={
                    <div className="controlled-example tooltip-main">
                      <span
                        className="controlled-example_close-button"
                        onClick={() => setOpenTooltip(null)}
                      >
                        <i className="ic-clearclose"></i>
                      </span>
                      <p>VAT Back % = 12% of DI Gross %</p>
                    </div>
                  }
                  open={openTooltip === props.name}
                  tagName="span"
                  position="bottom"
                  trigger="manual"
                  interactive={true}
                  animateFill={false}
                  arrow={true}
                  arrowSize="small"
                  className="tooltip-outer"
                />
              </>
            )
          )}
          {props.isVerified && (
            <img src={checkIcon} style={{ width: '15px', height: '15px', position: 'absolute', right: '10px', top: '15px' }} alt="verified" />
          )}
        </div>
      ) : ["mobile", "pattern-format", "number-format"].includes(props.type) ? (
        <div class="material">
          <Formatter
            {...props}
            style={{ border: props.errorMessage ? "1px solid red" : "" }}
            className={
              props.className
                ? props.className
                : "form-input"
            }
            format={props.type === "pattern-format" ? props.format : null}
            title={labeltxtClass ? label : ""}
            onValueChange={(data, custom_event) => patternFormatChangeHandler(data, custom_event)}
            onBlur={blurHandler}
            allowEmptyFormatting
            onFocus={focusHandler}
            decimalScale={decimalScale}
          />
          {props.errorMessage ? (
            <div className="error-msg-txt">{props.errorMessage}</div>
          ) : (
            ""
          )}
          <label data-label={label} class={`form-label ${labeltxtClass}`}></label>
          {props.isVerified && (
            <img src={checkIcon} style={{ width: '15px', height: '15px', position: 'absolute', right: '10px', top: '15px' }} alt="verified" />
          )}
        </div>
      ) : null}
    </>
  )
}

export default withFormsy(FormsyInputField);